import { CloseIcon } from "@chakra-ui/icons";
import {
  Button,
  IconButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import Spinner from "common/components/spinner/Spinner";
import { constant } from "common/constant";
import colors from "common/theme/foundations/colors";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const CommonDeleteModel = (props) => {
  const {
    isOpen,
    onClose,
    type,
    handleDeleteData,
    ids,
    selectedValues,
    notCheckbox = false,
    onCancel,
  } = props;
  const [isLoading, setIsLoading] = useState(false);

  const isGenericAction = type?.startsWith("Complete") || type?.startsWith("Cancel");

  const handleDelete = () => {
    handleDeleteData(ids, selectedValues);
  };

  const handleClose = () => {
    if (onCancel) {
      onCancel();
    }
    onClose();
  };

  return (
    <div>
      <Modal onClose={handleClose} isOpen={isOpen} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{isGenericAction ? type : `Delete ${type}`}</ModalHeader>
          <IconButton
            size="xs"
            className="closeIcon"
            onClick={handleClose}
            icon={<CloseIcon />}
          />

          <ModalBody>
            {isGenericAction
              ? `Are you sure you want to ${type.toLowerCase()}?`
              : (notCheckbox
                ? `${constant.deleteSingleDesc} ${type}?`
                : `${constant.deleteDesc}  ${ids && ids.length} ${type}?`)}
          </ModalBody>
          <ModalFooter>
            <Button
              className="theme-btn2"
              variant="outline"
              size="sm"
              onClick={handleClose}
            >
              No
            </Button>
            <Button
              className="theme-btn3"
              colorScheme={type?.startsWith("Complete") ? "blue" : colors.red[500]}
              size="sm"
              ml={4}
              onClick={handleDelete}
              disabled={isLoading ? true : false}
            >
              {isLoading ? <Spinner /> : (isGenericAction ? type.split(' ')[0] : "Yes, Delete")}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default CommonDeleteModel;
